import { render, staticRenderFns } from "./r-sky-common-config-dialog.vue?vue&type=template&id=f2fc7b08"
import script from "./r-sky-common-config-dialog.vue?vue&type=script&lang=js"
export * from "./r-sky-common-config-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2fc7b08')) {
      api.createRecord('f2fc7b08', component.options)
    } else {
      api.reload('f2fc7b08', component.options)
    }
    module.hot.accept("./r-sky-common-config-dialog.vue?vue&type=template&id=f2fc7b08", function () {
      api.rerender('f2fc7b08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/server-events/skyrace/r-sky-common-config-dialog.vue"
export default component.exports